/** Narrows an untyped payload node to an object, or null. */
export function record(value: unknown): Record<string, unknown> | null {
  return typeof value === "object" && value !== null ? (value as Record<string, unknown>) : null
}

/** Strict boolean: anything that is not literally `true` is false. */
export function bool(value: unknown): boolean {
  return value === true
}

/** Finite number, or 0 — never NaN leaking into arithmetic. */
export function int(value: unknown): number {
  return typeof value === "number" && Number.isFinite(value) ? value : 0
}

/** String, or "" — never `undefined` leaking into a template. */
export function text(value: unknown): string {
  return typeof value === "string" ? value : ""
}

/** One of a known enum, falling back when the server adds a value we predate. */
export function oneOf<T extends string>(value: unknown, allowed: T[], fallback: T): T {
  return allowed.includes(value as T) ? (value as T) : fallback
}
